module.exports = __webpack_public_path__ + "static/img/business.904f2b6c.png";